import { ONE_MINUTE, generateUUID, createValueHistory, elapsed, combine } from '@datadog/browser-core';
import { trackEventCounts } from './trackEventCounts';
export const EVENT_CONTEXT_TIME_OUT_DELAY = 5 * ONE_MINUTE; // arbitrary
export function startEventTracker(lifeCycle) {
    // Used by actions to associate events with actions.
    const history = createValueHistory({ expireDelay: EVENT_CONTEXT_TIME_OUT_DELAY });
    // Used by manual actions and resources that use named keys to match the start and stop calls.
    const keyedEvents = new Map();
    function cleanUpEvent(event) {
        var _a;
        keyedEvents.delete(event.key);
        (_a = event.eventCounts) === null || _a === void 0 ? void 0 : _a.stop();
    }
    function discardAll() {
        keyedEvents.forEach((event) => {
            cleanUpEvent(event);
        });
        history.reset();
    }
    const sessionRenewalSubscription = lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, discardAll);
    function start(key, startClocks, data, options) {
        const id = generateUUID();
        const historyEntry = history.add(id, startClocks.relative);
        const existing = keyedEvents.get(key);
        if (existing) {
            cleanUpEvent(existing);
        }
        const eventCounts = (options === null || options === void 0 ? void 0 : options.isChildEvent)
            ? trackEventCounts({
                lifeCycle,
                isChildEvent: options.isChildEvent(id),
            })
            : undefined;
        const trackedEventData = {
            id,
            key,
            startClocks,
            data,
            historyEntry,
            eventCounts,
        };
        keyedEvents.set(key, trackedEventData);
        return trackedEventData;
    }
    function stop(key, stopClocks, extraData) {
        var _a;
        const event = keyedEvents.get(key);
        if (!event) {
            return undefined;
        }
        const finalData = extraData ? combine(event.data, extraData) : event.data;
        event.historyEntry.close(stopClocks.relative);
        const duration = elapsed(event.startClocks.timeStamp, stopClocks.timeStamp);
        const counts = (_a = event.eventCounts) === null || _a === void 0 ? void 0 : _a.eventCounts;
        cleanUpEvent(event);
        return {
            ...finalData,
            id: event.id,
            startClocks: event.startClocks,
            duration,
            counts,
        };
    }
    function discard(key) {
        var _a;
        const event = keyedEvents.get(key);
        if (!event) {
            return undefined;
        }
        const counts = (_a = event.eventCounts) === null || _a === void 0 ? void 0 : _a.eventCounts;
        cleanUpEvent(event);
        event.historyEntry.remove();
        return {
            ...event.data,
            id: event.id,
            startClocks: event.startClocks,
            counts,
        };
    }
    function findId(startTime) {
        return history.findAll(startTime);
    }
    function getCounts(key) {
        var _a, _b;
        return (_b = (_a = keyedEvents.get(key)) === null || _a === void 0 ? void 0 : _a.eventCounts) === null || _b === void 0 ? void 0 : _b.eventCounts;
    }
    function stopTracker() {
        sessionRenewalSubscription.unsubscribe();
        discardAll();
        history.stop();
    }
    return {
        start,
        stop,
        discard,
        getCounts,
        findId,
        stopAll: stopTracker,
    };
}
//# sourceMappingURL=eventTracker.js.map